import {Injectable} from '@angular/core'
import {Observable, of} from 'rxjs'
import {HttpClient} from '@angular/common/http'
import {ElementUszkodzenia} from './types/element-uszkodzenia';
import {map, share} from 'rxjs/operators';
import {SlownikCache} from './cache/slownik.cache';
import {SlownikUszkodzen} from '../../model/uszkodzenia/slownik-uszkodzen';
import {RodzajElementu} from './types/rodzaj-elementu';
import {SlownikRodzajElementu} from '../../model/rodzaj-elementu/slownikRodzajElementu';
import {AtrybutyElementuUszkodzenia} from './types/atrybuty-elementu-uszkodzenia';


@Injectable({providedIn: 'root'})
export class SlownikService {

  private slownikCache = new SlownikCache();

  constructor(private http: HttpClient) {
  }

  pobierzElementyUszkodzen(slownikiUszkodzen: SlownikUszkodzen[], sortujWgPriorytetowWyswietlania: boolean): Observable<ElementUszkodzenia[]> {
    const brakujeWCache: SlownikUszkodzen[] = [];
    const slownikiZCache: ElementUszkodzenia[] = [];

    slownikiUszkodzen.forEach(s => {
      const cache = this.slownikCache.pobierzSlownikElementuUszkodzen(s.nazwa);
      cache ? slownikiZCache.push(cache) : brakujeWCache.push(s)
    });

    if (brakujeWCache.length === 0) {
      return of(this.sortujIMapujNaElementyUszkodzen(slownikiUszkodzen, slownikiZCache, sortujWgPriorytetowWyswietlania));
    }

    return this.http.post<ElementUszkodzenia[]>(this.pobierzSlowniElementuUszkodzeniaUrl(), brakujeWCache.map(bwc => bwc.nazwa))
      .pipe(
        map(elementy => {
          const elementyPobrane = elementy.map(element => {
            let elementUszkodzenia;
            const slownik = slownikiUszkodzen.find(s => s.nazwa === element.nazwa)
            if (slownik) {
              if (slownik.atrybuty) {
                slownik.atrybuty.pokazRodzajePowierzchni = !!element.rodzajePowierzchni
                slownik.atrybuty.pokazMaterialyWykonczenia = !!element.materialyWykonczenia
              }
              elementUszkodzenia = {
                ...element,
                nazwa: slownik.nazwa,
                opis: slownik.opis,
                domyslnaWartoscUszkodzenia: slownik.domyslnaWartosc,
                czyGrupowac: slownik.czyGrupowac,
                atrybuty: slownik.atrybuty as AtrybutyElementuUszkodzenia
              } as ElementUszkodzenia
              this.slownikCache.dodajSlownikElementuUszkodzen(slownik.nazwa, elementUszkodzenia)
            }
            return elementUszkodzenia;
          });
          const elementyPobraneOrazCache = elementyPobrane.filter((el): el is ElementUszkodzenia => !!el).concat(slownikiZCache)
          return this.sortujIMapujNaElementyUszkodzen(slownikiUszkodzen, elementyPobraneOrazCache, sortujWgPriorytetowWyswietlania);
        })
      )
  }

  pobierzRodzajElementu(slownikRodzajElementu: SlownikRodzajElementu): Observable<RodzajElementu> {

    const slownik = this.slownikCache.pobierzSlownikRodzajElementu(slownikRodzajElementu.nazwa);
    if (slownik) {
      return new Observable(subscriber => {
        subscriber.next(slownik)
      });
    }
    const slownikObservable = this.http.get<RodzajElementu>(this.pobierzSlowniRodzajElementuUrl(slownikRodzajElementu.nazwa)).pipe(map(rodzajElementu  => (
      {...rodzajElementu,
        nazwa: slownikRodzajElementu.nazwa
      })),  share());
    slownikObservable.subscribe(response => {
      this.slownikCache.dodajSlownikRodzajElementu(slownikRodzajElementu.nazwa, response);
    })
    return slownikObservable;
  }

  private pobierzSlowniElementuUszkodzeniaUrl(): string {
    return `/sag/slownik/uszkodzenie/`
  }

  private pobierzSlowniRodzajElementuUrl(nazwaSlownika: string): string {
    return `/sag/slownik/rodzajElementu/${nazwaSlownika}/`
  }

  private sortujIMapujNaElementyUszkodzen(slownikiUszkodzen: SlownikUszkodzen[], elementyUszkodzen: ElementUszkodzenia[], sortujWgPriorytetowWyswietlania: boolean): (ElementUszkodzenia)[] {
    let wynikoweSlownikiUszkodzen;
    if (sortujWgPriorytetowWyswietlania) {
      wynikoweSlownikiUszkodzen = slownikiUszkodzen.sort((a, b) => a.priorytetWyswietlania - b.priorytetWyswietlania);
    } else {
      wynikoweSlownikiUszkodzen = slownikiUszkodzen;
    }
    return wynikoweSlownikiUszkodzen
      .map(slownik => elementyUszkodzen.find(element => element.nazwa === slownik.nazwa))
      .filter((element): element is ElementUszkodzenia => !!element)
  }
}
